import { JwtHelperService } from '@auth0/angular-jwt';
import { Utilisateur } from '../models/utilisateur.model';
import { AuthCoreService } from './auth-core.service';

export abstract class AuthAbstractService<U extends Utilisateur> extends AuthCoreService {

	constructor(public jwtHelper: JwtHelperService) {
		super(jwtHelper);
	}

	getUtilisateurConnecte(): U {
		const token = super.decoderToken();
		if (token != null) {
			return this.construireUtilisateurDepuisToken(token);
		}
		return null;
	}

	abstract construireUtilisateurDepuisToken(token: any): U;
}
